/** Prepare saved Flow content before submitting it for review.
 * Preparation failures do not undo saved questionnaire edits or activate it.
 */
import axios from 'axios';

const pending = ['queued', 'generating', 'preparing_review', 'publication_queued', 'publishing'];
export async function prepareFlowForReview(questionnaire, getState, onProgress = () => {}, options = {}) {
  if (questionnaire.whatsappFlowsEnabled === false || process.env.REACT_APP_FLOW_DRAFT_ADMIN !== 'true')
    return null;
  const token = getState().authData?.[0]?.signInUserSession?.accessToken?.jwtToken;
  const config = {
    params: { tenantId: questionnaire.tenantId, questionnaireId: questionnaire.id },
    headers: { Authorization: `Bearer ${token}` },
  };
  const url = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/whatsapp-flows/draft`;
  const delay = options.delay || (() => new Promise((resolve) => setTimeout(resolve, 3000)));
  try {
    let data = options.initialData || (await axios.get(url, config)).data;
    // Deploy the runtime first. Old environments retain their current workflow.
    if (!data.automaticPreparationEnabled || data.whatsappFlowsEnabled === false) return null;
    onProgress({ pending: true });
    let requestedOperation;
    for (let attempt = 0; attempt < 100; attempt++) {
      if (data.reviewSubmitted && data.questionnaireStatus === 'underReview' &&
          data.operationId === requestedOperation) {
        onProgress(null);
        return { ...questionnaire, status: 'underReview', isActive: false, updatedAt: data.updatedAt };
      }
      if (!pending.includes(data.status)) {
        if (requestedOperation && data.operationId === requestedOperation) {
          const error = new Error('Flow preparation needs attention before this questionnaire can be submitted.');
          error.flowPreparation = data;
          throw error;
        }
        ({ data } = await axios.post(url, { action: 'submit_review' }, config));
        // A save may already be generating. Wait for it, then request the
        // fenced review transition; do not treat its readiness as submission.
        if (data.reviewRequested) requestedOperation = data.operationId;
      }
      await delay();
      ({ data } = await axios.get(url, config));
    }
    throw new Error('Preparation is still running. Check its progress here before submitting again.');
  } catch (error) {
    error.isFlowPreparationError = true;
    onProgress({ error: error.message, result: error.flowPreparation });
    throw error;
  }
}
